// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

/**
 * The logo's timing: it rests (static) for `REST_S`, then plays once — the X
 * morphs into a building part, holds, and morphs back — and rests again with
 * the next part queued. DOM-free; the component owns the clock.
 */

export const MORPH_OUT_S = 1.8;
export const HOLD_S = 1.4;
export const MORPH_BACK_S = 1.8;
/** When the hold ends (MORPH_OUT_S + HOLD_S, written out so it is exact in floating point). */
const HOLD_END_S = 3.2;
/** One play, start to finish (HOLD_END_S + MORPH_BACK_S). */
export const PLAY_S = 5.0;
/** Seconds at rest between plays. */
export const REST_S = 10;

/** How far into the part the X is, 0 (X) … 1 (part), `elapsed` seconds into a play. */
export function morph(elapsed: number): number {
  if (!(elapsed > 0)) return 0;
  if (elapsed < MORPH_OUT_S) return elapsed / MORPH_OUT_S;
  if (elapsed < HOLD_END_S) return 1;
  if (elapsed < PLAY_S) return 1 - (elapsed - HOLD_END_S) / MORPH_BACK_S;
  return 0;
}

/** The play is over. */
export function isDone(elapsed: number): boolean {
  return elapsed >= PLAY_S;
}

/** The part after `index`, wrapping around `count`. */
export function nextPart(index: number, count: number): number {
  return count > 0 ? (index + 1) % count : 0;
}
